import script from "./SafeWeekSummaryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SafeWeekSummaryCard.vue?vue&type=script&setup=true&lang=js"

import "./SafeWeekSummaryCard.vue?vue&type=style&index=0&id=2472e8cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2472e8cf"]])

export default __exports__